require("../tm-support-chat/module");

(function (angular) {

  angular.module("tm.navButtonsThreeStack", ["tm.supportChat"])

})(window.angular);

require("./tmNavButtonsThreeStack.directive");


// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/tm-nav-buttons-three-stack/module.js